/**
 * Standardized icon sizing constants for lucide-react icons
 * Ensures consistent icon sizing across all components
 */

export const ICON_SIZES = {
  // Extra small - used for badges, small decorations
  BADGE: 12,
  
  // Small - used for labels, inline icons
  SMALL: 14,
  
  // Medium - default size for most interactive elements
  MEDIUM: 16,
  
  // Medium-Large - used for menu icons, toggle buttons
  MENU: 24,
  
  // Large - prominent action buttons, decorative icons
  LARGE: 18,
  
  // Extra large - card decorations, hero icons
  XLARGE: 28,
  
  // Huge - major section icons
  HUGE: 34,
  
  // Giant - full-width section headers
  GIANT: 54,
};

export const STROKE_WIDTHS = {
  // Thin strokes for small icons
  THIN: 1.9,
  
  // Standard stroke width
  STANDARD: 2.1,
  
  // Bold stroke for emphasis
  BOLD: 2.2,
};

const iconConfig = {
  ICON_SIZES,
  STROKE_WIDTHS,
};

export default iconConfig;
